import { render, staticRenderFns } from "./build-logs.vue?vue&type=template&id=aabb37a8&scoped=true&"
import script from "./build-logs.vue?vue&type=script&lang=js&"
export * from "./build-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabb37a8",
  null
  
)

export default component.exports